import ComponentRepository from './architecture/componentRepository';

document.addEventListener('DOMContentLoaded', function () {
    window.cr = new ComponentRepository({
        //'media-lazy-loader': () => import('./components/media-lazy-loader'),
        header: () => import('./components/top-navigation'),
        'hero-swiper': () => import('./components/hero-swiper'),
        'media-swiper': () => import('./components/media-swiper'),
        'image-grid-swiper': () => import('./components/image-grid-swiper'),
        'image-gallery': () => import('./components/image-gallery'),
        accordion: () => import('./components/accordion'),
        'top-navigation': () => import('./components/top-navigation'),
        'top-navigation-mobile': () =>
            import('./components/top-navigation-mobile'),
        'mobile-menu': () =>
            import('./components/mobile-menu'),
        'top-navigation-search': () =>
            import('./components/top-navigation-search'),
        search: () => import('./components/search'),
        'split-text': () => import('./components/split-text'),
        'in-viewport': () => import('./components/in-viewport'),
        'jobseeker-hero': () => import('./components/jobseeker-hero'),
        swiper: () => import('../../node_modules/swiper/swiper-bundle.js'),
        modal: () => import('./components/modal'),
        map: () => import('./components/map'),
        'toggle-button': () => import('./components/toggle-button'),
        'mobile-submenu': () => import('./components/mobile-submenu'),
        'tab-section-accordion': () =>
            import('./components/tab-section-accordian'),
        'job-filter': () => import('./components/JobFilter/job-filter'),
        'job-filter-overview': () =>
            import('./components/JobFilterOverview/job-filter-overview'),
    });
});
